import { Component, OnInit } from '@angular/core';
import { CoreService } from 'src/app/core/_services/core.services';
import { AppMainComponent } from './../../app.main.component';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[];

    constructor(
        public coreService: CoreService,
        public app: AppMainComponent
    ) { }

    ngOnInit() {
        this.app.sidebarActive = false;
        this.model = [
            /*
            {
                label: 'Inicio',
                icon: 'pi pi-fw pi-home',
                routerLink: ['/']
            },
            {
                label: 'Volumen de Datos',
                icon: 'pi pi-fw pi-chart-line',
                routerLink: ['/volumen-datos']
            },
            {
                label: 'Solicitudes Backend',
                icon: 'fa fa-fw fa-cog',
                routerLink: ['/solicitudes-backend']
            },
            {
                label: 'Ficha', 
                icon: 'fa fa-fw fa-cog', 
                routerLink: ['/ficha']
            },
            {
                label: 'Consultas',
                icon: 'fa fa-search', 
                routerLink: ['/consultas']
            },
            {
                label: 'Ficha', 
                icon: 'fa fa-fw fa-cog', 
                routerLink: ['/ficha']
            },
            {
                label: 'FiltroCandidatos', 
                icon: 'fa fa-fw fa-cog', 
                routerLink: ['/filtro-candidatos']
            },
            {
                label: 'Head Hunter', 
                icon: 'fa fa-briefcase', 
                routerLink: ['/head-hunter']
            },
            {
                label: 'Consultas', 
                icon: 'fa fa-search', 
                routerLink: ['/consultas']
            },
            {
                label: 'Ejecutar Consultas', 
                icon: 'fa fa-search', 
                routerLink: ['/ejecutar-consulta']
            },
            {
                label: 'Consultar Procesos', 
                icon: 'fa fa-search', 
                routerLink: ['/estado-proceso']
            },
            {
                label: 'Procesos Contratación', 
                icon: 'fa fa-search', 
                routerLink: ['/proceso-contratacion']
            }
            */
        ];
    }

    onMenuClick() {
        this.app.menuClick = true;
    }


}
